export default __webpack_public_path__ + "static/media/dna_kit_number_step0.2a2545aa.svg";